import { aiApi } from '@/lib/api/ai'
import { useOrganizationStore } from '@/store/organization.store'
import { useQuery } from '@tanstack/react-query'

export function useAICredits(feature: string, enabled = true) {
  const organizationId = useOrganizationStore(
    state => state.currentOrganization?.id,
  )

  return useQuery({
    queryKey: ['ai-credits', organizationId, feature],
    queryFn: () => aiApi.getCreditStatus(feature),
    enabled: enabled && !!organizationId,
    staleTime: 15_000,
    refetchOnWindowFocus: true,
  })
}
